"use strict";

module.exports = {
    injectIntoThis: true,
    injectInto: null,
    properties: ["spy", "stub", "mock", "clock", "server", "requests"],
    useFakeTimers: true,
    useFakeServer: true
};



/** WEBPACK FOOTER **
 ** ./~/sinon/lib/sinon/util/core/default-config.js
 **/